export const COOKIE_PAGE_SIZE = 'pageSize';
export const LANDING_SESSION_COOKIE = 'landingSession';
